import * as yup from "yup";
import { createEmailSchema } from "./schemaUtils";

export const forgotPasswordSchema = yup.object().shape({
    email: createEmailSchema({
      requiredMessage: "Email is required",
      invalidMessage: "Please enter a valid email address",
    }),
  });
